export class MailData {
    
        constructor(public secretkey?: string,
            public domain?: string,
            public sendtoaddr?: string,
            public sendfromaddr?: string,
            public hash?: string,
            public createdAt?: string) { }
    }


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/classes/mail-data.class.ts